import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Compact Sun/Moon toggle used in page headers.
 *
 * Styling intentionally mirrors the existing ghost icon-buttons already
 * in each header (back-arrow, settings icons) so it slots in without
 * visual noise. Icon swaps based on current theme — Moon shown in dark
 * (tap to switch to light), Sun shown in light (tap to switch to dark).
 */
export const ThemeToggle = ({ className = '', size = 'md' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const px = size === 'sm' ? 'p-1.5' : 'p-2';
  const icon = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      data-testid="theme-toggle"
      className={`${px} rounded-sm text-zinc-400 hover:text-white hover:bg-white/5 transition-colors ${className}`}
    >
      {isDark ? <Moon className={icon} /> : <Sun className={icon} />}
    </button>
  );
};

export default ThemeToggle;
